import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  index(params) {
    const url = FetchHelpers.toCDN(apiRoutes.categoryPath(1, params));
    return FetchHelpers.get(url);
  },
};
